import {useCallback, useMemo} from 'react';
import {useNode} from '@craftjs/core';
import {isMobile} from 'react-device-detect';

interface IUseEditorStyleProps {
  setProp: ReturnType<typeof useNode>['actions']['setProp'];
}

type PropType = {
  style: React.CSSProperties;
  mobileStyle: React.CSSProperties;
};

const useEditorStyle = (props?: IUseEditorStyleProps) => {
  const device = isMobile ? 'mobile' : 'desktop';

  const {desktopStyle, mobileStyle} = useNode(node => ({
    desktopStyle: node.data.props.style,
    mobileStyle: node.data.props.mobileStyle,
  }));

  const style = useMemo(() => {
    return {...desktopStyle, ...(device === 'mobile' ? mobileStyle : {})} as React.CSSProperties;
  }, [device, desktopStyle, mobileStyle]);

  const updateStyle = useCallback(
    (key: keyof React.CSSProperties, value: any) => {
      if (device === 'desktop') {
        props?.setProp((prop: PropType) => {
          prop.style[key] = value;
        });
      }
      if (device === 'mobile') {
        props?.setProp((prop: PropType) => {
          prop.mobileStyle[key] = value;
        });
      }
    },
    [device, props],
  );

  return {device, style, updateStyle};
};

export default useEditorStyle;
